<template>
  <div>

    <div>
      <van-overlay :show="digshow" @click="">
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="dig_titile">查询您的报考信息</div>
            <van-form @submit="onSubmit" style="width: 90%;margin: 0 auto;margin-top: 40px;">
              <div style="line-height: 30px;font-weight: bold;" class="roule">手机号：</div>
              <van-field v-model="useriphone" placeholder="请输入您的报考手机号"
                style="border: 1px #ebedf0 solid;border-radius: 10px;" />
              <!-- <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" /> -->
              <div style="margin: 16px;margin-top: 30px;">
                <van-button round block type="danger" native-type="submit">查询</van-button>
              </div>
            </van-form>
            <div class="text1">请输入您报考时填写的手机号，来确定您的个人信息，进行补充填写。</div>
          </div>


        </div>
      </van-overlay>

    </div>
    <div class="qs-bg" id="body" v-if="!digshow">
      <div class="item" id="sex">
        <p>*<span>性别</span></p>
        <div style="border: 1px #c3c3c3 solid;padding: 12px;border-radius: 7px;">
          <van-radio-group v-model="data.sex" direction="horizontal">
            <van-radio name="0" checked-color="#FF921A">男</van-radio>
            <van-radio name="1" checked-color="#FF921A" style="margin-left: 40px">女</van-radio>
          </van-radio-group>
        </div>
      </div>
      <!-- {{ columns }} -->
      <div class="item" id="educationBackground">
        <p>*<span>最高学历</span></p>
        <div>
          <van-field readonly is-link clickable name="picker" :value="educationBackgroundName" placeholder="请选择"
            @click="showPicker3 = true" />
          <van-popup v-model="showPicker3" position="bottom">
            <van-picker title="最高学历" show-toolbar
              :columns="projectId == 1 ? columns.filter(item => item.listClass === 'warning') : columns"
              @confirm="onConfirm3" />
          </van-popup>
        </div>
      </div>

      <div class="item" id="studentDegree"
        v-if="projectId == 1 ? data.educationBackground >= 12 : data.educationBackground >= 50">
        <!-- 军队文职 ：12
        央国企：50  -->
        <p>*<span>学位</span></p>
        <div>
          <van-cell-group>
            <div>
              <van-field readonly is-link clickable name="picker" :value="studentDegreeName" placeholder="请选择"
                @click="showPicker7 = true" />

              <van-popup v-model="showPicker7" position="bottom">
                <van-picker title="学位" show-toolbar :columns="academicDegree.filter(item => item.listClass === 'warning')" @confirm="onConfirm7" />
              </van-popup>
            </div>
            <!-- <van-field v-model="data.studentDegree" placeholder="请输入" /> -->
            <!-- academicDegree -->
          </van-cell-group>
        </div>
      </div>

      <div class="item" id="graduationYear" v-if="projectId != '1'">
        <p>*<span>毕业年份</span></p>
        <div>
          <van-field readonly is-link clickable name="picker" :value="graduationYearName" placeholder="请选择"
            @click="yearGraduationModal = true" />
          <van-popup v-model="yearGraduationModal" position="bottom">
            <van-picker title="毕业年份" show-toolbar :columns="yearGraduation" @confirm="yearGraduationConfirm" />
          </van-popup>
        </div>
      </div>

      <div class="item" id="educationBackground"  v-if="data.educationBackground >= 12">
        <p><span>请选择专业</span></p>
        <div>
          <van-field readonly is-link clickable name="picker" :value="showPicker6Name" placeholder="请选择"
            @click="showPicker6 = true" />
          <van-popup v-model="showPicker6" position="bottom">
            <van-picker title="专业" show-toolbar :columns="columns6" @confirm="onConfirm6"
              :columns-field-names="customFieldName" value-key="name" />
          </van-popup>
        </div>
      </div>


      <div class="item" id="major">
        <p><span>专业</span><span v-if="data.educationBackground >= 12">（没有合适的专业可以手动输入）</span></p>
        <div>
          <van-cell-group>
            <van-field v-model="data.major" placeholder="请输入" />
          </van-cell-group>
        </div>
      </div>

      <div class="item" id="isNine">
        <p>*<span>是否985</span></p>
        <div>
          <van-radio-group v-model="data.isNine" direction="horizontal">
            <van-radio name="1" checked-color="#FF921A">是</van-radio>
            <van-radio name="0" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="item" id="isTwo">
        <p>*<span>是否211</span></p>
        <div>
          <van-radio-group v-model="data.isTwo" direction="horizontal">
            <van-radio name="1" checked-color="#FF921A">是</van-radio>
            <van-radio name="0" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="item" id="isFirst">
        <p>*<span>是否双一流</span></p>
        <div>
          <van-radio-group v-model="data.isFirst" direction="horizontal">
            <van-radio name="1" checked-color="#FF921A">是</van-radio>
            <van-radio name="0" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="item" id="partyMember">
        <p>*<span>是否党员</span></p>
        <div>
          <van-radio-group v-model="data.partyMember" direction="horizontal">
            <van-radio name="Y" checked-color="#FF921A">是</van-radio>
            <van-radio name="N" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="item" id="retirement">
        <p>*<span>是否退役军人</span></p>
        <div>
          <van-radio-group v-model="data.retirement" direction="horizontal">
            <van-radio name="Y" checked-color="#FF921A">是</van-radio>
            <van-radio name="N" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>

       <div class="item" id="isArmyMate">
        <p>*<span>是否军人配偶</span></p>
        <div>
          <van-radio-group v-model="data.isArmyMate" direction="horizontal">
            <van-radio :name="1" checked-color="#FF921A">是</van-radio>
            <van-radio :name="0" checked-color="#FF921A" style="margin-left: 40px">否</van-radio>
          </van-radio-group>
        </div>
      </div>
  <div class="item" id="majorStatus">
        <p>*<span>专业技术/职业资格</span></p>
        <div>
          <van-radio-group v-model="data.majorStatus" direction="horizontal">
            <van-radio name="1" checked-color="#FF921A">有</van-radio>
            <van-radio name="0" checked-color="#FF921A" style="margin-left: 40px">无</van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="item" id="idAttributes" v-if="projectId == '1'">
        <p>*<span>身份属性(高校毕业生 社会人才)</span></p>
        <div>
          <van-field readonly is-link clickable name="picker" :value="data.idAttributes" placeholder="请选择"
            @click="showPicker4 = true" />
          <van-popup v-model="showPicker4" position="bottom">
            <van-picker title="身份属性" show-toolbar :columns="columns2" @confirm="onConfirm4" />
          </van-popup>
        </div>
      </div>

    
      <!-- isArmyMate -->

      <div class="item">
        <p>*<span>户籍所在地省市区</span></p>
        <div>
          <van-field v-model="fieldValue" is-link readonly label="地区" placeholder="请选择所在地区" @click="showArea = true" />
        </div>
      </div>

      <div class="item" id="majorKeyword" v-if="projectId != '1'">
        <p>*<span>专业岗位关键词</span></p>
        <div>
          <div v-if="textList.length" style="margin-bottom: 10px;">
            <van-tag closeable size="medium" type="primary" style="margin-right: 10px;background-color: #e02020;"
              v-for="(item, index) in textList" :key="index" @close="close(index)">{{
                item
              }}</van-tag>
          </div>
          <div style="display: flex;justify-content: space-between;">
            <van-field v-model="text" placeholder="请输入关键词" style="width: 80%;" />
            <van-button style="background-color: #e02020; color: #fff;border-radius: 4px;"
              @click="addText">添加</van-button>
          </div>
        </div>
      </div>

      <div class="item" id="intentionArea">
        <p>*<span>报考的意向地区</span></p>
        <div>
          <div v-if="intentionAera.length" style="margin-bottom: 10px;">
            <van-tag closeable size="medium" type="primary" style="margin-right: 10px;background-color: #e02020;"
              v-for="(item, index) in intentionAera" :key="index" @close="close2(index)">{{
                item
              }}</van-tag>
          </div>
          <div style="display: flex;justify-content: space-between;">
            <van-field v-model="intentionAeraText" placeholder="请输入关键词" style="width: 80%;" />
            <van-button style="background-color: #e02020;color: #fff;border-radius: 4px;"
              @click="addTextIntention">添加</van-button>
          </div>
        </div>
        <div style="width: 100%;line-height: 24px;color:red;font-size: 12px;">输入报考地区后，请点击后面添加！</div>
      </div>

      <!-- <div class="item" id="koseki">
      <p>*<span>户籍所在地(省份)</span></p>
      <div>
        <van-cell-group>
          <van-field v-model="data.koseki" placeholder="请输入" />
        </van-cell-group>
      </div>
    </div>

    <div class="item" id="kosekiCity">
      <p>*<span>户籍所在地(城市)</span></p>
      <div>
        <van-cell-group>
          <van-field v-model="data.kosekiCity" placeholder="请输入" />
        </van-cell-group>
      </div>
    </div>
   
    <div class="item" id="major">
      <p>*<span>专业</span></p>
      <div>
        <van-cell-group>
          <van-field v-model="data.major" placeholder="请输入" />
        </van-cell-group>
      </div>
    </div> -->

      <van-popup v-model="showArea" round position="bottom">
        <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
      </van-popup>

      <div class="btn-wrap">
        <!-- <van-button :loading="false" type="primary" /> -->
        <!-- <van-button loading type="primary" loading-type="spinner" /> -->
        <van-button :loading="btnLoading" :disabled="btnLoading" loading-type="spinner" loading-text="提交中..."
          @click.stop="handleSubmit">确认提交</van-button>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import { Field } from "vant";
import { RadioGroup, Radio } from "vant";
import areaList from "@/libs/111.js";
import { Area } from "vant";
import { DropdownMenu, DropdownItem, Cascader } from "vant";
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
import { DatetimePicker, Tag } from "vant";
Vue.use(DatetimePicker);
Vue.use(Area);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tag);
import { Picker } from "vant";
Vue.use(Picker);
Vue.use(Field);
// 配合地区数据包使用
// import { areaList } from '@vant/area-data';
// console.log("Cascader", Cascader, DropdownItem)
// Vue.use(Cascader);
import "vant/lib/index.css";
import { Toast } from "vant";
import { studentsave, getinfo, getsignStatus, getMajorSelect, getDictType, postStudentFull,majorArmySelect } from "@/api/xicaiquan";
import { checkMobile } from '@/api/activity'
import { digest } from "js-md5";
export default {
  name: "ask",
  data() {
    return {
      academicDegree: [],//学位
      digshow: true,//弹窗验证手机号
      useriphone: '',
      projectId: undefined,//区分项目
      value1: 0,
      columns: [],
      columns2: ["高校毕业生", "社会人才"],
      yearGraduation: [
        // {
        //   text: "不限",
        //   value: 0,
        // },
        // {
        //   text: "23",
        //   value: "23"
        // },
        // {
        //   text: "24",
        //   value: "24"
        // },
        // {
        //   text: "25",
        //   value: "25"
        // },
        // {
        //   text: "26",
        //   value: "26"
        // },
        // {
        //   text: "27",
        //   value: "27"
        // },
        // {
        //   text: "28",
        //   value: "28"
        // },{
        //   text: "29",
        //   value: "29"
        // }
      ],
      yearGraduationModal: false,
      showPicker4: false,
      areaList,
      isshow: false,
      showArea: false,
      currentType: "1",
      data: {
        studentType: "1",
        // address: "",
        educationBackground: "",
        idAttributes: "",
        koseki: "",
        kosekiCity: "",
        // logisticsAddress: "",
        major: "",
        // mobile: "",
        partyMember: "",
        // realName: "",
        retirement: "",
        sex: "",
        studentDegree: "",
        isFirst: "",
        isTwo: "",
        isNine: "",
        koseki: "",
        // kosekiCity: "",
        kosekiArea: "",
        kosekiCode: "",
        kosekiCityCode: "",
        kosekiAreaCode: "",
        // majorStatus:0,
      },
      showPicker: false,
      showPicker3: false,//学历
      showPicker7:false, //学位弹窗
      message: "",
      btnLoading: false,
      datalist: [
        // {
        //   con: "",
        //   titile: "快递邮寄地址",
        //   contype: "address",
        // },
        {
          con: "",
          titile: "最高学历",
          contype: "educationBackground",
        },
        // {
        //   con: "",
        //   titile: "身份属性",
        //   contype: "idAttributes",
        //   projectId: '0'
        // },
        {
          con: "",
          titile: "户籍所在省",
          contype: "koseki",
        },
        {
          con: "",
          titile: "户籍市区",
          contype: "kosekiCity",
        },
        {
          con: "",
          titile: "是否985",
          contype: "isNine",
        },
        {
          con: "",
          titile: "是否211",
          contype: "isTwo",
        },
        {
          con: "",
          titile: "是否双一流",
          contype: "isFirst",
        },
        // {
        //   con: "",
        //   titile: "身份属性",
        //   contype: "idAttributes",
        //   projectId: '0'
        // },
        // {
        //   con: "",
        //   titile: "毕业年份",
        //   contype: "graduationYear",
        //   projectId: '1'
        // },
        {
          con: "",
          titile: "专业技术/职业资格",
          contype: "majorStatus",
        },




        // {
        //   con: "",
        //   titile: "详细地址",
        //   contype: "logisticsAddress",
        // },
        // {
        //   con: "",
        //   titile: "专业",
        //   contype: "major",
        // },
        // {
        //   con: "",
        //   titile: "手机号",
        //   contype: "mobile",
        // },
        {
          con: "",
          titile: "是否党员",
          contype: "partyMember",
        },
        // {
        //   con: "",
        //   titile: "真实姓名",
        //   contype: "realName",
        // },
        {
          con: "",
          titile: "是否退役",
          contype: "retirement",
        },
        {
          con: "",
          titile: "性别",
          contype: "sex",
        },
      ],
      showArea: false,
      fieldValue: "",
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: "浙江省",
          value: "330000",
          children: [{ text: "杭州市", value: "330100" }],
        },
        {
          text: "江苏省",
          value: "320000",
          children: [{ text: "南京市", value: "320100" }],
        },
      ],
      text: "",
      textList: [],
      educationBackgroundName: "", //学历
      studentDegreeName: "", //学位

      graduationYearName: "",
      showPicker6: false,
      columns6: [],
      showPicker6: false,
      showPicker6Name: "",
      customFieldName: {
        text: "name",
        children: "children",
        value: "name",
      },
      intentionAera: [],
      intentionAeraText: "",
    };
  },
  methods: {
    //查询报考信息是否存在
    onSubmit() {
      if (this.useriphone == '') { return Toast('请填写手机号') }
      console.log(this.useriphone, '-----')
      checkMobile({ phone: this.useriphone, projectId: this.$route.query.projectId }).then(res => {
        if (res.code == 200) {
          // console.log(res.data.data,'----')
          if (res.data.isExists == false) {
            Toast('未查询到手机号用户，请联系您的班主任！')
          }
          if (res.data.isExists == true) {
            this.digshow = false
            this.data.userInfoId = res.data.userInfoId
          }
        }
        console.log(res, '-===')
      })
    },
    // onConfirm(value) {
    //   console.log(value, "===");
    //   console.log(value, "====");
    //   this.data.address = "";
    //   for (let i = 0; i < value.length; i++) {
    //     if (!value[i].name) {
    //       Toast("请选择");
    //       return;
    //     }
    //     this.data.address += value[i].name;
    //     this.showPicker = false;
    //   }
    // },

    addText() {
      if (!this.text) return;
      this.textList.push(this.text);
      this.text = "";
    },
    addTextIntention() {
      if (!this.intentionAeraText) return;
      this.intentionAera.push(this.intentionAeraText);
      this.intentionAeraText = "";
    },

    onConfirm3(value) {
      console.log(value, '-----');
      this.data.educationBackground = "";
      this.educationBackgroundName = value.text;
      this.data.educationBackground = value.value;
      this.showPicker3 = false;
    },
    //学位
    onConfirm7(value) {
      this.studentDegreeName = value.text;
      this.data.studentDegree = value.value;
      this.showPicker7=false
    },
    onConfirm4(value) {
      this.data.idAttributes = "";
      this.data.idAttributes = value;
      this.showPicker4 = false;
    },
    onConfirm5(value) {
      console.log(value);
    },
    yearGraduationConfirm(value) {
      console.log(value)
      this.graduationYearName = value.text;
      this.data.graduationYear = value.value;
      this.yearGraduationModal = false;
    },
    onConfirm6(data) {
      console.log(data);
      this.data.categorySelect = data[0];
      this.data.majorCategorySelect = data[1];
      this.data.majorSelect = data[2];

      this.showPicker6Name = data.join("/");
      this.showPicker6 = false;
    },
    onConfirm(values) {
      console.log(values);
      this.selectedArea = values.map((item) => item.name).join("/");
      console.log(this.selectedArea);
      this.fieldValue = this.selectedArea;
      this.showArea = false;

      this.data.koseki = values[0].name;
      this.data.kosekiCode = values[0].code;

      this.data.kosekiCity = values[1].name;
      this.data.kosekiCityCode = values[1].code;

      this.data.kosekiArea = values[2].name;
      this.data.kosekiAreaCode = values[2].code;
    },
    getAskList() {
      // this.data.formId=this.$route.query.formId
      // studentsave(this.data).then(res => {
      //   console.log(res, '===')
      // })
      // return
      getsignStatus().then((res) => {
        // 0 未填写问卷
        // 1 未签署合同
        // 2 已经签署合同
        if (res.code == "200") {
          if (res.data == "0") {
            this.isshow = true;
          } else if (res.data == "1") {
            if (this.$route.query.linkType != "3") {
              this.isshow = false;
              Toast("问卷已经填写过");
              return;
            }
            this.$router.push({
              path: "/concat",
              query: {
                templateId: this.$route.query.templateId,
              },
            });
          } else {
            this.$router.push({
              path: "/contractok",
              query: {
                templateId: this.$route.query.templateId,
              },
            });
          }
        }

        console.log(res, "核实个人消息");
      });
    },
    getarrtitle(num) {
      // console.log('调用我了',num)
      var title = "";
      for (let i = 0; i < this.datalist.length; i++) {
        if (this.datalist[i].contype == num) {
          title = this.datalist[i].titile;
          return title;
        }
      }
    },
    //删除关键词
    close(indexToRemove) {
      // console.log(item,'====')
      this.textList = this.textList.filter((_, index) => index !== indexToRemove);
      // console.log(this.textList,'===')
    },
    close2(indexToRemove) {
      this.intentionAera = this.intentionAera.filter((_, index) => index !== indexToRemove);
    },
    handleSubmit() {
      console.log(this.$route.query.studentType, "===");
      //单独给一个空值
      
      // return
      // for (var index in this.datalist) {
      //   if (!["studentDegree", "major"].includes(index)) {
      //     var title = this.getarrtitle(index);
      //     }
      //     console.log(index, "index")
      //   if (this.data[index] == "") {
      //     Toast(`${title}不能为空`);
      //     console.log(index);
      //     document.getElementById(`${index}`).scrollIntoView();
      //     return;
      //   }
      // }
      for (const item of this.datalist) {
        if (!this.data[item.contype]) {
          Toast(`${item.titile}不能为空`);
          document.getElementById(`${item.contype}`).scrollIntoView();
          return; // 直接退出整个函数
        }
      }
      if (this.textList.length <= 0 && this.projectId != '1') {
        Toast('专业岗位关键词不能为空');
        return
      }
      if (this.intentionAera.length <= 0) {
        Toast('报考意向地区不能为空');
        return
      }
      // if (item.contype == 'studentDegree') {
      // if () {
      if (this.data.studentDegree == '' && this.data.educationBackground >= 50) {
        Toast(`学位不能为空`);
        document.getElementById(`studentDegree`).scrollIntoView();
        return
      }
      // }
      // }
      // console.log(this.data, "----");

      // return
      console.log(this.textList.join(' '))
      console.log(this.data, "----");
      this.btnLoading = true;
      this.data.intentionArea = this.intentionAera.join(' ')
      if (this.projectId != '1') {
        this.data.majorKeyword = this.textList.join(' ')
      }
      this.data.formId = this.$route.query.formId;
      // this.data.code = this.$route.query.code;
      this.data.projectId = this.$route.query.projectId

      console.log(this.data, '=====')
      // return
      postStudentFull(this.data).then((res) => {
        this.btnLoading = false;
        if (res.code == "200") {
          // this.isshow = false;
          // if (this.$route.query.linkType == "3") {
          //   this.getAskList();
          // }
          Toast("提交成功，感谢您的参与");
          // this.$route.push('/pageok')
          this.$router.push({
            path: "/pageok",

          });
        }
      });
    },

    async getMajorSelect() {
      const res = await majorArmySelect({});
      if (res.code == 200) {
        this.columns6 = res.data;
      }
    },
    async getDictType(type, target, callback) {
      const res = await getDictType(type, target, callback);
      if (res.code == 200) {
        res.data.forEach(item => {
          // if(target=='education'){}
          // warning
          this[target].push({
            text: item.dictLabel,
            value: item.dictValue,
            listClass: item.listClass
          });
        })
        callback && callback(this[target]);
      }
    },
  },
  mounted() {
    this.projectId = this.$route.query.projectId

    this.getMajorSelect();
    // projectId
    if (this.projectId == '1') {
      this.getDictType("education", "columns")

    } else {
      this.getDictType("education_new", "columns")
    }

    // 学位

    this.getDictType("academic_degree", "academicDegree")
    this.getDictType("graduation_year", "yearGraduation")
    // this.getAskList();
    if (this.projectId == '1') {
      this.datalist.push(
        {
          con: "",
          titile: "身份属性",
          contype: "idAttributes",

        },
      )
    } else {
      this.datalist.push(
        {
          con: "",
          titile: "毕业年份",
          contype: "graduationYear",

        },
      )
    }
  },
};
</script>

<style lang="scss" scoped>

.item /deep/ .van-picker-column .van-ellipsis{
  font-size: 12px !important;
}
.roule::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.wrapper {
  display: flex;
  // align-items: center;
  margin-top: 20vh;
  justify-content: center;
  // height: 100%;
}

.dig_titile {
  font-size: 16px;
  line-height: 50px;
  width: 100%;
  text-align: center;
  color: rgb(224, 32, 32);
  font-weight: bold;
}

.text1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  line-height: 20px;
  margin-top: 40px;
  color: #969799;
}

.block {
  width: 90%;
  // height: 40vh;
  // height: 40%;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 40px;
}

.qs-bg {
  width: 100%;
  height: auto;
  min-height: 100vh;
  background: #fff;
  padding-bottom: 30px;
  // padding-top: 40px;
}

.ask-bg {
  width: 100%;
  height: 1.8rem;
}

.notice {
  width: 100%;
  //   height: 1.9rem;
  // margin: 0.34rem auto 0 auto;
  margin: 0 auto;
  // background: rgba(#FE8000, .05);

  // background: #fff8f3;
  border-radius: 9px;
  // border: 1px solid #fecd8e;
  font-size: 0.14rem;
  // font-family: PingFang-SC-Regular, PingFang-SC;
  // font-weight: 400;
  // color: #fe620e;/
  // line-height: 0.3rem;
  // padding: 0.1rem 0.1rem;
}

.item {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;

  >p {
    color: rgb(224, 32, 32);
    font-size: 15px;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 10px;

    >span {
      // color: #FE620E;
      color: #717171;
      font-size: 15px;
      font-weight: bold;
      margin-left: 5px;
    }
  }
}

.item /deep/ .van-cell {
  border: 1px #c3c3c3 solid;
  border-radius: 7px;
}

.item /deep/ .van-cell .van-field__body {
  font-size: 16px;
}

.item>div /deep/ .van-popup .van-picker__toolbar .van-picker__cancel {
  visibility: hidden;
}

.item /deep/ .van-tag--primary {
  background-color: rgb(224, 32, 32);
  ;
}

.btn-wrap {
  //   position: fixed;
  //   z-index: 998;
  width: 100%;
  height: 0.7rem;
  margin-top: 40px;

  >button {
    display: block;
    width: 3.24rem;
    height: 0.48rem;
    background: rgb(224, 32, 32);
    // box-shadow: 0px 5px 10px 0px rgba(#fe8000, 0.31);
    border-radius: 10px;
    font-size: 17px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    margin: 0.1rem auto;
  }
}

.btn-wrap /deep/ .van-button .van-button__content {
  font-size: 18px;
}

.textarea {
  width: 3.15rem;
  // height: 1.22rem;
  border-radius: 4px;
  border: 1px solid rgba(189, 189, 189, 1);
  border: 1px solid rgba(189, 189, 189, 1);
  margin-top: 0.24rem;
}

.mytext {
  /deep/.van-field__label {
    display: none;
  }
}
</style>
